import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const NoResultsState = () => {
  return (
    <Grid container justifyContent="center" mt={4} size={12}>
      <Grid container justifyContent="center" mb={2}>
        <Typography sx={{ textAlign: 'center' }} variant="h3">
          <FormattedMessage id="SearchResultsPanel.noResultsHeading" />
        </Typography>
      </Grid>
      <Grid container justifyContent="center" sx={{ display: { xs: 'flex', md: 'none' } }}>
        <Typography variant="body1">
          <FormattedMessage id="SearchResultsPanel.noResultsSubHeading" />
        </Typography>
      </Grid>
      <MapOutlinedIcon sx={{ fontSize: '16em', color: 'rgba(14,67,96,0.05)' }} />
    </Grid>
  );
};

export default NoResultsState;
